import React from 'react';

// Logo variants tuned to the new brand: green padel-racket monogram + wordmark.
const Logo = ({ brand, invert = false, showWordmark = false, tagline = false, className = '' }) => {
  const src = brand?.logo_data_url || '/padel-gems-logo.png';
  const wordText = invert ? 'text-[#F5F0E6]' : 'text-[#141414]';
  const taglineText = invert ? 'text-[#F5F0E6]/70' : 'text-[#0F2E23]/70';

  return (
    <div className={`inline-flex items-center gap-3 ${className}`}>
      <img src={src} alt="Padel Gems" className="h-10 sm:h-14 lg:h-16 w-auto object-contain" />
      {showWordmark && (
        <div className="leading-tight">
          <div className={`font-display text-lg sm:text-xl lg:text-2xl tracking-[0.14em] font-bold ${wordText}`}>PADEL GEMS</div>
          {tagline && (
            <div className={`text-[9px] sm:text-[10px] lg:text-[11px] tracking-[0.32em] mt-0.5 ${taglineText}`}>PLAY  ·  CONNECT  ·  BELONG</div>
          )}
        </div>
      )}
    </div>
  );
};

export default Logo;
